import type { FC, ReactNode } from 'react';
import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { MeinOrtShowAllButton } from '@/features/mein-ort/components/funkzentrale/MeinOrtShowAllButton';
import { Row } from '@/shared/components/layout/Row';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    section: { marginBottom: 24 },
    header: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    titleWrap: { alignItems: 'center', flexShrink: 1 },
    title: {
      fontSize: 16,
      fontWeight: '500',
      lineHeight: 24,
      color: theme.colors.onSurface
    }
  });

export const MeinOrtChannelSection: FC<{
  title: string;
  onMore: () => void;
  children: ReactNode;
  /** Stable identifier for E2E selectors (e.g. the MeinOrtTab key). */
  sectionKey: string;
}> = memo(({ title, onMore, children, sectionKey }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={styles.section} testID={`mein-ort-section-${sectionKey}`}>
      <Row style={styles.header}>
        <Row style={styles.titleWrap}>
          <Text style={styles.title} numberOfLines={1}>
            {title}
          </Text>
        </Row>
        <MeinOrtShowAllButton
          onPress={onMore}
          testID={`mein-ort-show-all-${sectionKey}`}
        />
      </Row>
      {children}
    </View>
  );
});
MeinOrtChannelSection.displayName = 'MeinOrtChannelSection';
